// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationOutput-cls1_Ro4","cls2":"CitationOutput-cls2_z2h CitationOutput-cls1_Ro4"};